// extracted by mini-css-extract-plugin
export default {"wrapper":"s9XAChXMcAz_KsQ0WLNS","title":"R_n9fU3r3OyazZxVZomj","subtitle":"bRgEJSZ0ZJjSk8Z6xXZ2"};